import { readInt32, writeInt32 } from './StreamUtil';

class Command {
	// Routing
	static REGISTER_UPLINK = 101;

	// Device management
	// Alive
	static PING_QUERY = 111;

	static PING_REPLY = 112;

	static HEARTBEAT = 113;

	// Status
	static QUERY_DEVICE_STATUS = 121;

	static PUBLISH_DEVICE_STATUS = 122;

	// Data related

	// Stream data
	static START_STREAMING = 211;

	static STOP_STREAMING = 212;

	static STREAMING_DATA_PACKET = 213;

	static STREAMING_TYPE_PACKET = 214;

	// Recording data
	static START_RECORDING = 221;

	static STOP_RECORDING = 222;

	// Transferring data
	static START_TRANSFER = 231;

	static TRANSFER_DATA = 232;

	static STOP_TRANSFER = 233;

	static DELETE_FILE = 234;

	// DeviceRegistry data
	static QUERY_DEVICE_REGISTRY = 301;

	static PUBLISH_DEVICE_REGISTRY = 302;

	static DEVICE_REGISTERED = 303;

	static DEVICE_UNREGISTERED = 304;

	constructor(command, sender, recipient) {
		this.command = command || null;
		this.sender = sender || null;
		this.recipient = recipient || null;
	}

	read(input) {
		this.sender = readInt32(input);
		this.recipient = readInt32(input);
	}

	write(output) {
		writeInt32(output, this.command);
		writeInt32(output, this.sender);
		writeInt32(output, this.recipient);
	}

	toByteArray() {
		const buffer = [];
		this.write(buffer);
		const resp = new Uint8Array(buffer);
		return resp;
	}
}

export default Command;
